import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AboutUsPageCTASection.scss';
import RocketLaunchRoundedIcon from '@mui/icons-material/RocketLaunchRounded';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';

const AboutUsPageCTASection = () => {
  const navigate = useNavigate();

  const handleJoinAsFreelancer = () => {
    navigate('/become-a-freelancer');
  };

  const handleHireTalent = () => {
    navigate('/categories');
  };

  return (
    <section className="cta-section">
      <div className="cta-container">
        <div className="cta-content">
          <h2 className="cta-title">Ready To Be Part Of The Revolution?</h2>
          <p className="cta-description">
            The future of freelancing in India starts with you. Whether you're a talented freelancer ready to break free from unfair platforms, or a business looking for quality Indian talent, <strong>your revolution begins today.</strong>
          </p>
          
          <div className="cta-buttons">
            <button className="cta-button primary" onClick={handleJoinAsFreelancer}>
              <RocketLaunchRoundedIcon className="button-icon" />
              Join As Freelancer
            </button>
            
            <button className="cta-button secondary" onClick={handleHireTalent}>
              <PersonRoundedIcon className="button-icon" />
              Hire Revolutionary Talent
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUsPageCTASection;
